export const RAZORPAY_POLL_INTERVAL_MS = 3000;
export const RAZORPAY_POLL_TIMEOUT_MS = 90_000;
export const RAZORPAY_DISMISS_POLL_MS = 20_000;
export const RAZORPAY_TIMEOUT_POLL_INTERVAL_MS = 10_000;
export const PAYMENT_RECOVERY_KEY = 'razorpay_checkout';

export interface RazorpayOptions {
  key: string;
  order_id: string;
  name?: string;
  description?: string;
  handler?: () => void;
  modal?: { ondismiss?: () => void };
  [key: string]: unknown;
}

declare global {
  interface Window {
    Razorpay?: new (options: RazorpayOptions) => { open(): void };
  }
}

let loadPromise: Promise<void> | null = null;

export function loadRazorpayCheckout(): Promise<void> {
  if (loadPromise) return loadPromise;
  loadPromise = new Promise<void>((resolve, reject) => {
    if (window.Razorpay) { resolve(); return; }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Razorpay script failed to load'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
}
